import React from 'react'
 
import Home from '../UI/Home'
import Service from '../UI/Service'
import Banner from '../UI/Banner'
import Trust from '../UI/Trust'
import Progress from '../UI/Progress'
import Recent from '../UI/Recent'
import Acorden from '../UI/Acorden'
import Testimonials from '../UI/Testimonials'
// import Contact from '../UI/Contact'

const Main = () => {
  return (
    <div>
        
 <Home/>
 <Service/>
 <Banner/>
 <Trust/>
 <Progress/>
 <Recent/>
 <Acorden/>
 <Testimonials/>
 {/* <Contact/> */}
 
    </div>
  )
}

export default Main